import React, {useEffect, useState} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import MonthlyTable from "./monthly-table.jsx";
import WeeklyTable from "./weekly-table.jsx";

const ReportContent = ({data, type}) => {
    const [firstType, setFirstType] = useState("")
    let labels = [...new Set(data.monthlyData.flatMap(item => Object.keys(item)))]
    const weekColumns = data.columns.map(title => ({
        field: data.fieldMap[title],
        title
    }))

    useEffect(() => {
        setFirstType(type)

        data.monthlyData.sort((a, b) => {
            const totalA = a["Total"] ?? 0;
            const totalB = b["Total"] ?? 0;
            return totalB - totalA;
        });

        const weekLabels = [
            "Natureza",
            ...weekColumns.map(c => {
                return c.title
            }),
            "Total",
            "Média",
            "Diferença absoluta dos últimos 15 dias",
            "Diferença percentual dos últimos 15 dias"
        ];

        const weekValues = data.weeklyData.map(element => [
            element.natures,
            ...weekColumns.map(c => element[c.field] ?? 0),
            element.total,
            element.media,
            (element.diff_15 > 0 ? '+' : '') + element.diff_15,
            (element.percent_diff_15 > 0 ? '+' : '') + element.percent_diff_15 + "%"
        ]);
        ReportUtils.createExportableTable(null, null, "Análise Mensal", "displacement-monthly-data");
        ReportUtils.createExportableTable(weekLabels, weekValues, "Análise Semanal");
    }, [data]);

    return (
        <>
            <MonthlyTable data={data} firstType={firstType} labels={labels}/>

            <WeeklyTable data={data} firstType={firstType} weekColumns={weekColumns}/>

            <div id="chart-tables"></div>

        </>
    );
};

export default ReportContent;